// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".otp-form{&[data-v-11235a8c]{display:flex;justify-content:center;gap:4px}input[data-v-11235a8c]{border-radius:10px;display:inline-block!important;border:2px solid #006ea5!important;width:50px!important;height:50px!important;text-align:center!important}}.full-width{&[data-v-11235a8c]{margin-top:20px}.input-field[data-v-11235a8c]{width:100%}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
